export enum PaymentError {
  OrderPaid = 'OrderPaid'
}
